import { MediaType } from 'constants/media'
import { IMedia } from 'interfaces/media'

export function extractMediaByType(mediaList: IMedia[], type: MediaType): IMedia[] {
  const imageMedia: IMedia[] = Array.isArray(mediaList)
    ? mediaList?.filter((media: IMedia) => media?.mediaType === type)
    : []

  return imageMedia
}

export function convertToEmbedLink(url: string): string {
  const youTubeRegExp: RegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  const match = String(url)?.toLowerCase()?.match(youTubeRegExp)
  return match?.[2] ? `https://www.youtube.com/embed/${match[2]}` : url
}

export function getOfficeAppLiveUrl(url: string): string {
  if (String(url)?.toLowerCase()?.includes('pdf')) {
    return `https://docs.google.com/viewer?url=${url}&embedded=true`
  }
  const encodedUrl = encodeURIComponent(url)
  return `https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}&wdOrigin=BROWSELINK`
}
